module.exports = __webpack_public_path__ + "img/ic_mpe_larm_press.dbe2d960.png";